import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import {AppStore} from './modules/app';
import {AttendanceStore} from './modules/attendance';
import {EmployeeStore} from './modules/employee';
import { IRootState } from '@/models/State';

Vue.use(Vuex);

const store: StoreOptions<IRootState> = {
    modules: {
        AppStore,
        EmployeeStore,
    },
};

export default new Vuex.Store<IRootState>(store);
